// Dependencies
import PortalVue from "portal-vue";
import TextareaAutosize from "vue-textarea-autosize";

// Register plugins
export default Vue => {
  Vue.use(PortalVue);
  Vue.use(TextareaAutosize);
};
